export class DeliveryRateCard {
  rateId: number;
  sourceCity?: string;
  sourceCountry?: string;
  sourceCityId?: number;
  sourceCountryId?: number;
  destinationCity?: string;
  destinationCountry?: string;
  destinationCityId?: number;
  destinationCountryId?: number;
  vehicleConfigId: number;
  vehicleTypeId: number;
  vehicleCapacityId: number;
  distance: number;
  amount: number;
  // A new rate card defaults these optional inclusions to "Excluded". Leaving
  // them undefined causes Angular to serialize null, while the API requires
  // concrete boolean values.
  goodsInsurance = false;
  portPermit = false;
  waitingThreshold: number;
  waitingCharge: number;
  rateType?: string;
  unitBasis?: string;
  transitTime?: string;
  buyingCompanyId: number;
  sellingCompanyId: number;
  contractRevisionId: number;
  sourceQuotationId?: number;
  sourceQuotationLineId?: number;
  contractId?: number;
  contractNumber?: string;
  revisionNumber?: string;
  revisionStatus?: string;
  buyingCompanyName?: string;
  sellingCompanyName?: string;
  sourceCountryName?: string;
  destinationCountryName?: string;
  sourceCityName?: string;
  destinationCityName?: string;
  vehicleTypeName?: string;
  vehicleConfigName?: string;
  vehicleCapacityName?: string;
}
